import VueJwtDecode from 'vue-jwt-decode'

import axios from 'axios'
// import routes from '@src/router/views/user/routes'

export const services = {
  getCandidatesNameIcon,
  getMainMenuList,
  findDate,
  apiService,
  fileApiService,
  b64toBlob,
  decodeJWT,
  saveAuth,
  getAuth,
  setDefaultAuthHeaders,
  logOut,
  getHeaderAuthorization,
  searchSubMenu,
  searchActions,
  authorized,
  removeAuth,
  saveToLocalStorage,
  getLocalStorage,
}
function setDefaultAuthHeaders(token) {
  axios.defaults.headers.common.Authorization = token ? 'JWT ' + token : ''
}
function getHeaderAuthorization() {
  // console.log(authorized())
  if (!authorized()) return { common: { authorization: 'JWT ' + getAuth() } }
  else {
    //  console.log('entered')
    window.location.href = '/session-out'
  }
}
function getCandidatesNameIcon(currentUser) {
  let data = {}
  if (currentUser['last_name'] !== undefined) {
    if (currentUser['last_name'].charAt(0) !== null)
      data['profileIcon'] =
        currentUser['first_name'].charAt(0).toUpperCase() +
        currentUser['last_name'].charAt(0).toUpperCase()
    else data['profileIcon'] = currentUser['first_name'].charAt(0).toUpperCase()
    data['fullName'] =
      currentUser['first_name'] +
      ' ' +
      (currentUser['last_name'] !== null ? currentUser['last_name'] : '')
  } else {
    if (currentUser['surname'] !== undefined)
      if (currentUser['surname'].charAt(0) !== null)
        data['profileIcon'] =
          currentUser['firstName'].charAt(0).toUpperCase() +
          currentUser['surname'].charAt(0).toUpperCase()
      else
        data['profileIcon'] = currentUser['firstName'].charAt(0).toUpperCase()
    data['fullName'] =
      currentUser['firstName'] +
      ' ' +
      (currentUser['surname'] !== null ? currentUser['surname'] : '')
  }
  data['email'] = currentUser.email

  return data
}
function saveAuth(token) {
  window.localStorage.setItem('auth', token)
  setDefaultAuthHeaders(token)
}
function saveToLocalStorage(name, value) {
  window.localStorage.setItem(name, value)
}
function getLocalStorage(name) {
  return window.localStorage.getItem(name)
}
function removeAuth() {
  window.localStorage.removeItem('auth')
}
function logOut() {
  window.localStorage.removeItem('auth')
  window.localStorage.removeItem('signature')
  window.localStorage.removeItem('user')
}
function getAuth() {
  return window.localStorage.getItem('auth')
}
function getMainMenuList(currentUser) {
  if (currentUser.isStaff) {
    return [
      {
        name: 'userdashboard',
        title: 'DASHBOARD',
        icon: 'tachometer-alt',
        class: 'dashboard',
      },

      /*  {
              name: 'userform',
              title: 'Forms',
              icon: 'file-alt',
            }, */
      {
        name: 'settings',
        title: 'SETTINGS',
        class: 'settings',
        icon: 'cog',
      },
      {
        name: 'userlogout',
        title: 'LOGOUT',
        class: 'logout',
        icon: 'cog',
      },
    ]
  } else {
    return [
      {
        name: 'userdashboard',
        title: 'DASHBOARD',
      },

      {
        name: 'form',
        title: 'APPLICATIONS',
      },
      {
        name: 'settings',
        title: 'SETTINGS',
      },
      {
        name: 'userlogout',
        title: 'LOGOUT',
      },
      {
        name: 'appsettings',
        title: 'APP SETTINGS',
      },
      {
        name: 'staffmanagment',
        title: 'STAFF MANAGMENT',
      },
    ]
  }
}
function findDate(value) {
  let currentYear = new Date().getFullYear()

  var month = new Date().getMonth()
  var day = new Date().getDate()

  return new Date(currentYear + value, month, day)
}
function apiService(api, userid, formid) {
  let apiStringSet = api.split('#')
  var x = apiStringSet.findIndex((y) => y === 'userid')
  if (x !== -1) apiStringSet[x] = userid
  if (formid !== null) {
    var i = apiStringSet.findIndex((y) => y === 'formid')
    apiStringSet[i] = formid
  }
  let apiString = apiStringSet.join('/')
  // console.log(apiString.charAt(apiString.legth-1))
  if (apiString.charAt(apiString.length - 1) === '/') {
    // let m=apiString.substring(0,apiString.legth-1)
    return apiString.substring(0, apiString.length - 1)
  } else return apiStringSet.join('/')
}
function fileApiService(api, userid, formid, fileid) {
  let apiStringSet = api.split('#')
  var x = apiStringSet.findIndex((y) => y === 'userid')
  if (x !== -1) apiStringSet[x] = userid
  if (formid !== null) {
    var i = apiStringSet.findIndex((y) => y === 'formid')
    apiStringSet[i] = formid
  }
  if (fileid !== null) {
    var j = apiStringSet.findIndex((y) => y === 'fileid')
    apiStringSet[j] = fileid
  }
  let apiString = apiStringSet.join('/')
  // console.log(apiString.charAt(apiString.legth-1))
  if (apiString.charAt(apiString.length - 1) === '/') {
    // let m=apiString.substring(0,apiString.legth-1)
    return apiString.substring(0, apiString.length - 1)
  } else return apiStringSet.join('/')
}
function b64toBlob(b64Data, contentType, name, sliceSize) {
  contentType = contentType || ''
  sliceSize = sliceSize || 512
  name = name || 'image'

  var byteCharacters = atob(b64Data)
  var byteArrays = []

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize)

    var byteNumbers = new Array(slice.length)
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    var byteArray = new Uint8Array(byteNumbers)

    byteArrays.push(byteArray)
  }

  // var blob = new Blob(byteArrays, { type: contentType })
  //
  var blob = new File(byteArrays, name, {
    //
    type: contentType,
    //
  })
  return blob
}
function searchSubMenu(nameKey, myArray) {
  for (var i = 0; i < myArray.length; i++) {
    if (myArray[i].title === nameKey) {
      return myArray[i].subMenu
    }
  }
}
function searchActions(nameKey, myArray) {
  for (var i = 0; i < myArray.length; i++) {
    if (myArray[i].title === nameKey) {
      return myArray[i].actions
    }
  }
}
function authorized() {
  var token = getAuth()
  if (token !== null) {
    var data = VueJwtDecode.decode(token)

    return Date.now() > data.exp * 1000
  } else return true
}
function decodeJWT(token) {
  // console.log(token)

  return VueJwtDecode.decode(token)
}
